import React, { useState, useEffect } from "react";
import {
  Drawer,
  Typography,
  List,
  Divider,
  Tabs,
  Collapse,
  Tag,
  Spin,
  Tooltip,
  Modal,
  message
} from "antd";
import { InputItem, ButtonItem, CheckItem } from "../../../../Components/Items";
import {
  ExportOutlined,
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  SwapOutlined,
  ExpandOutlined,
} from "@ant-design/icons";
import ModalTarea from "./ModalTarea";
import ChatLeadWhatsapp from "./ChatLeadWhatsapp";
import axios from "axios";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import moment from "moment";
import "moment/locale/es";

const { Title, Text } = Typography;
const { TabPane } = Tabs;
const { Panel } = Collapse;

const DrawerLead = ({
  visible,
  lead,
  onClose,
  onToggleTarea,
  onAddTarea,
  onUpdateComentario,
  onEditarLead,
  colorEtapa,
  headersToken,
  history,
  esMaster,
  onReasignar,
  onAbrirChatModal,
  tieneWhatsapp,
}) => {
  const [datosExtra, setDatosExtra] = useState([]);
  const [cargandoDatos, setCargandoDatos] = useState(false);
  // Estado del ModalTarea
  const [modalTareaVisible, setModalTareaVisible] = useState(false);
  const [tareaEditando, setTareaEditando] = useState(null);
  // Modal de eliminar
  const [modalEliminarVisible, setModalEliminarVisible] = useState(false);
  const [tareaAEliminar, setTareaAEliminar] = useState(null);
  const [textoConfirmacion, setTextoConfirmacion] = useState("");
  const [loadingEliminar, setLoadingEliminar] = useState(false);

  const puedeEliminar = textoConfirmacion.trim().toLowerCase() === "eliminar";

  useEffect(() => {
    if (visible && lead?._id) {
      setCargandoDatos(true);
      axios
        .post(
          "leads/datosPorLeadId",
          { leadId: lead._id },
          { headers: headersToken },
        )
        .then((res) => {
          if (res.data.success === 2) setDatosExtra(res.data.datosExtra);
        })
        .finally(() => setCargandoDatos(false));
    } else {
      setDatosExtra([]);
    }
  }, [visible, lead?._id, headersToken]);

  if (!lead) return null;

  const abrirModalNueva = () => {
    setTareaEditando(null);
    setModalTareaVisible(true);
  };

  const abrirModalEditar = (tarea) => {
    setTareaEditando({
      id: tarea._id,
      title: tarea.titulo,
      descripcion: tarea.descripcion,
      start: tarea.fechaInicio ? new Date(tarea.fechaInicio) : null,
      end: tarea.fechaFin ? new Date(tarea.fechaFin) : null,
      allDay: tarea.todoElDia,
      leadId: lead._id,
    });
    setModalTareaVisible(true);
  };

  const handleTareaGuardada = () => {
    axios
      .post(
        "leads/obtenerTareasLead",
        { leadId: lead._id },
        { headers: headersToken },
      )
      .then((res) => {
        if (res.data?.success === 2) {
          onUpdateComentario(lead._id, null, null, res.data.tareas);
        }
      });
  };

  const handleEliminarTarea = (tareaId) => {
    setTareaAEliminar(tareaId);
    setTextoConfirmacion("");
    setModalEliminarVisible(true);
  };

  const confirmarEliminar = () => {
    setLoadingEliminar(true);
    axios
      .post(
        "leads/eliminarTarea",
        { leadId: lead._id, tareaId: tareaAEliminar },
        { headers: headersToken },
      )
      .then((res) => {
        if (res.data.success === 2) {
          onUpdateComentario(lead._id, null, null, res.data.tareas);
          setModalEliminarVisible(false);
          setTareaAEliminar(null);
          setTextoConfirmacion("");
          message.success("Tarea eliminada correctamente"); 
        } else {
          message.error(res.data?.message || "Error al eliminar la tarea");
        }
      })
      .finally(() => setLoadingEliminar(false));
  };

  const irADocumento = (ruta, documentoId) => {
    history.push(`/panel/${ruta}`, { id: documentoId });
  };

  const telefonoMostrar = lead.numero || lead.contactoId?.numero || "N/A";
  const correoMostrar = lead.correo || lead.contactoId?.correo || "N/A";
  const colorTema = colorEtapa || "#1890ff";

  const datosPorTransicion = datosExtra.reduce((acc, dato) => {
    const key = dato.nombreTransicion || "Sin transición";
    if (!acc[key]) acc[key] = [];
    acc[key].push(dato);
    return acc;
  }, {});

  return (
    <>
      <Modal
        title="¿Eliminar tarea?"
        visible={modalEliminarVisible}
        onCancel={() => {
          setModalEliminarVisible(false);
          setTextoConfirmacion("");
        }}
        footer={
          <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
            <ButtonItem
              danger
              onClick={() => {
                setModalEliminarVisible(false);
                setTextoConfirmacion("");
              }}
            >
              Cancelar
            </ButtonItem>
            <ButtonItem
              rojo
              disabled={!puedeEliminar}
              loading={loadingEliminar}
              onClick={confirmarEliminar}
            >
              Eliminar
            </ButtonItem>
          </div>
        }
      >
        <Text style={{ display: "block", marginBottom: 12 }}>
          Esta acción no se puede deshacer. Escribe{" "}
          <Text strong>"eliminar"</Text> para confirmar.
        </Text>
        <InputItem
          placeholder='Escribe "eliminar" para confirmar'
          value={textoConfirmacion}
          onChange={(e) => setTextoConfirmacion(e.target.value)}
          onPressEnter={() => puedeEliminar && confirmarEliminar()}
        />
      </Modal>
      <ModalTarea
        visible={modalTareaVisible}
        tareaEditando={tareaEditando}
        leadIdFijo={lead._id}
        onGuardado={handleTareaGuardada}
        onCancel={() => setModalTareaVisible(false)}
      />

      <Drawer
        title={
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
              paddingRight: "20px",
            }}
          >
            <Text
              strong
              style={{ fontSize: "16px", color: "#ffffff", maxWidth: "70%" }}
              ellipsis
            >
              {lead.descripcion}
            </Text>
            <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
              {esMaster && (
                <Tooltip
                  title="Reasignar Lead"
                  placement="top"
                  overlayInnerStyle={{
                    fontSize: "10px",
                    padding: "1px 5px",
                    minHeight: "auto",
                  }}
                >
                  <ButtonItem
                    negro2
                    icon={<SwapOutlined />}
                    onClick={() => onReasignar && onReasignar(lead)}
                    style={{
                      color: "#fa8c16",
                      borderColor: "#fa8c16",
                      display: "flex",
                      alignItems: "center",
                      padding: "0 8px",
                    }}
                  />
                </Tooltip>
              )}
              <Tooltip
                title="Editar Lead"
                placement="top"
                overlayInnerStyle={{
                  fontSize: "10px",
                  padding: "1px 5px",
                  minHeight: "auto",
                }}
              >
                <ButtonItem
                  negro2
                  icon={<EditOutlined />}
                  onClick={() => onEditarLead(lead)}
                  style={{
                    color: "#ffffff",
                    display: "flex",
                    alignItems: "center",
                    padding: "0 8px",
                  }}
                />
              </Tooltip>
            </div>
          </div>
        }
        placement="right"
        width={450}
        onClose={onClose}
        visible={visible}
        headerStyle={{ backgroundColor: colorTema }}
      >
        <Title level={5} style={{ color: colorTema, marginTop: 0 }}>
          Información del Contacto
        </Title>
        <p>
          <b>Nombre:</b> {lead.contactoId?.nombre}{" "}
          {lead.contactoId?.apellidoPaterno}
        </p>
        <p>
          <b>Teléfono:</b> {telefonoMostrar}
        </p>
        <p>
          <b>Correo:</b> {correoMostrar}
        </p>
        <p>
          <b>Valor Estimado:</b>{" "}
          {lead.valor != null ? `$${lead.valor.toLocaleString()}` : "Sin valor"}
        </p>
        {lead.insumoBuscadoId && (
          <p>
            <b>Insumo Buscado:</b>{" "}
            {lead.insumoBuscadoId.clave
              ? `${lead.insumoBuscadoId.clave} - ${lead.insumoBuscadoId.descripcion}`
              : lead.insumoBuscadoId.descripcion}
          </p>
        )}
        {lead.createdAt && (
          <p>
            <b>Fecha de creación:</b>{" "}
            {moment(lead.createdAt).format("DD/MM/YYYY HH:mm")}
          </p>
        )}
        {lead.externalId && (
          <p>
            <b>ID Externo:</b> {lead.externalId}
          </p>
        )}

        {lead.motivoPerdida && (
          <div
            style={{
              background: "#fff1f0",
              border: "1px solid #ffa39e",
              borderRadius: 6,
              padding: "8px 12px",
              marginTop: 8,
              marginBottom: 4,
            }}
          >
            <Text type="danger" style={{ fontSize: 11, display: "block" }}>
              Motivo de pérdida
            </Text>
            <Text strong style={{ color: "#cf1322" }}>
              {lead.motivoPerdida}
            </Text>
          </div>
        )}

        <Divider style={{ borderColor: colorTema, opacity: 0.3 }} />

        <Title level={5} style={{ color: colorTema }}>
          Tareas del Lead
        </Title>
        <ButtonItem negro2 icon={<PlusOutlined />} onClick={abrirModalNueva}>
          Nueva tarea
        </ButtonItem>

        <style>{`
          .tabs-tema-lead .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
            color: ${colorTema} !important;
          }
          .tabs-tema-lead .ant-tabs-ink-bar {
            background: ${colorTema} !important;
          }
          .tabs-tema-lead .ant-tabs-tab:hover .ant-tabs-tab-btn {
            color: ${colorTema} !important;
            opacity: 0.8;
          }
        `}</style>

        <Tabs defaultActiveKey="tareas" size="small" className="tabs-tema-lead" destroyInactiveTabPane>
          <TabPane tab="Tareas" key="tareas" >
            <List
              dataSource={lead.tareas || []}
              locale={{ emptyText: "No hay tareas para este lead" }}
              renderItem={(item) => {
                const tarea = item.tareaId;
                if (!tarea) return null;

                return (
                  <List.Item style={{ padding: "8px 0", display: "block" }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: 8,
                      }}
                    >
                      <CheckItem
                        checked={tarea.completado}
                        onChange={() => onToggleTarea(lead._id, tarea._id)}
                        className="checkitemFormBlack"
                        style={{ marginTop: "4px" }}
                      />
                      <div style={{ flex: 1 }}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <Text
                            delete={tarea.completado}
                            style={{
                              color: tarea.completado ? "#8c8c8c" : "inherit",
                              fontSize: 13,
                              fontWeight: "bold",
                            }}
                          >
                            {tarea.titulo}
                          </Text>
                          <div
                            style={{
                              display: "flex",
                              gap: 4,
                              alignItems: "center",
                            }}
                          >
                            {tarea.fechaInicio && (
                              <Tag
                                color="gray"
                                style={{
                                  fontSize: 10,
                                  margin: 0,
                                  padding: "0 4px",
                                }}
                              >
                                {moment(tarea.fechaInicio).format(
                                  tarea.todoElDia
                                    ? "DD/MM/YYYY"
                                    : "DD/MM/YYYY HH:mm",
                                )}
                              </Tag>
                            )}
                            <Tooltip title="Editar" placement="top">
                              <ButtonItem
                                size="small"
                                blanco
                                icon={<EditOutlined style={{ fontSize: 11 }} />}
                                onClick={() => abrirModalEditar(tarea)}
                                style={{ padding: "0 4px", height: 22 }}
                              />
                            </Tooltip>
                            <Tooltip title="Eliminar" placement="top">
                              <ButtonItem
                                size="small"
                                rojo
                                icon={
                                  <DeleteOutlined style={{ fontSize: 11 }} />
                                }
                                onClick={() => handleEliminarTarea(tarea._id)}
                                style={{ padding: "0 4px", height: 22 }}
                              />
                            </Tooltip>
                          </div>
                        </div>

                        {tarea.descripcion && (
                          <Text
                            style={{
                              display: "block",
                              fontSize: 12,
                              color: "#595959",
                              marginBottom: 4,
                            }}
                          >
                            {tarea.descripcion}
                          </Text>
                        )}

                        <InputItem
                          placeholder="+ Añadir nota rápida / comentario..."
                          defaultValue={tarea.comentario}
                          onBlur={(e) =>
                            onUpdateComentario(
                              lead._id,
                              tarea._id,
                              e.target.value,
                            )
                          }
                          onPressEnter={(e) => {
                            onUpdateComentario(
                              lead._id,
                              tarea._id,
                              e.target.value,
                            );
                            e.target.blur();
                          }}
                          sinBorde
                          style={{
                            fontSize: "11px",
                            padding: "2px 4px",
                            backgroundColor: "#f9f9f9",
                            marginTop: 2,
                          }}
                        />
                      </div>
                    </div>
                  </List.Item>
                );
              }}
            />
          </TabPane>

          {tieneWhatsapp && (
            <TabPane tab="WhatsApp" key="whatsapp">
              {onAbrirChatModal && (
                <div style={{ textAlign: "right", marginBottom: 8 }}>
                  <ButtonItem
                    blanco
                    size="small"
                    icon={<ExpandOutlined />}
                    onClick={() => onAbrirChatModal(lead)}
                  >
                    Abrir en pantalla
                  </ButtonItem>
                </div>
              )}
              <ChatLeadWhatsapp
                telefono={lead.numero || lead.contactoId?.numero}
                leadId={lead._id}
              />
            </TabPane>
          )}

          <TabPane tab="Mis Campos" key="camposPersonalizados">
            {(lead.camposPersonalizados || []).length === 0 ? (
              <Text
                type="secondary"
                style={{
                  display: "block",
                  textAlign: "center",
                  marginTop: 20,
                }}
              >
                Este lead aún no tiene campos personalizados registrados.
              </Text>
            ) : (
              <List
                dataSource={lead.camposPersonalizados}
                renderItem={(dato, i) => (
                  <List.Item
                    style={{
                      padding: "8px 0",
                      borderBottom:
                        i < lead.camposPersonalizados.length - 1
                          ? "1px solid #f0f0f0"
                          : "none",
                    }}
                  >
                    <div style={{ width: "100%" }}>
                      <Text type="secondary" style={{ fontSize: 11 }}>
                        {dato.nombreCampo}
                      </Text>
                      <br />
                      {dato.valor === true || dato.valor === "true" ? (
                        <Text style={{ fontSize: 16, color: "#52c41a" }}>
                          ✓
                        </Text>
                      ) : dato.valor === false || dato.valor === "false" ? (
                        <Text style={{ fontSize: 16, color: "#ff4d4f" }}>
                          ✗
                        </Text>
                      ) : dato.tipo === "date" && dato.valor ? (
                        <Text style={{ fontSize: 13 }}>
                          {moment(dato.valor, "DD/MM/YYYY").isValid()
                            ? moment(dato.valor, "DD/MM/YYYY").format(
                                "DD/MM/YYYY",
                              )
                            : String(dato.valor)}
                        </Text>
                      ) : (
                        <Text style={{ fontSize: 13 }}>
                          {String(dato.valor ?? "-")}
                        </Text>
                      )}
                    </div>
                  </List.Item>
                )}
              />
            )}
          </TabPane>

          {/* Tab de datos extra */}
          <TabPane tab="Historial de Transiciones" key="datos">
            <Spin spinning={cargandoDatos}>
              {lead.fechaEntradaEtapa && (
                <div
                  style={{
                    marginBottom: 12,
                    padding: "6px 10px",
                    backgroundColor: "#f8f8f8",
                    borderRadius: 6,
                    border: `1px solid ${colorTema}22`,
                  }}
                >
                  <Text type="secondary" style={{ fontSize: 11 }}>
                    Entrada a etapa actual
                  </Text>
                  <br />
                  <Text strong style={{ fontSize: 13 }}>
                    {moment(lead.fechaEntradaEtapa).format("DD/MM/YYYY HH:mm")}
                  </Text>
                </div>
              )}
              {Object.keys(datosPorTransicion).length === 0 &&
              !cargandoDatos ? (
                <Text
                  type="secondary"
                  style={{
                    display: "block",
                    textAlign: "center",
                    marginTop: 20,
                  }}
                >
                  Este lead aún no tiene datos registrados.
                </Text>
              ) : (
                <Collapse
                  bordered={false}
                  defaultActiveKey={Object.keys(datosPorTransicion)}
                  style={{ backgroundColor: "transparent" }}
                >
                  {Object.entries(datosPorTransicion).map(
                    ([nombreTransicion, datos]) => (
                      <Panel
                        key={nombreTransicion}
                        header={
                          <Text strong style={{ color: colorTema }}>
                            {nombreTransicion}
                          </Text>
                        }
                        style={{
                          marginBottom: 8,
                          backgroundColor: "#fafafa",
                          borderRadius: 8,
                          border: "1px solid #f0f0f0",
                        }}
                      >
                        {datos.map((dato, i) => (
                          <div
                            key={i}
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              padding: "6px 0",
                              borderBottom:
                                i < datos.length - 1
                                  ? "1px solid #f0f0f0"
                                  : "none",
                            }}
                          >
                            <div>
                              <Text type="secondary" style={{ fontSize: 11 }}>
                                {dato.nombreCampo}
                              </Text>
                              <br />
                              {dato.esDocumento ? (
                                <Tag color="blue" style={{ marginTop: 2 }}>
                                  {dato.stringBuscar}
                                </Tag>
                              ) : dato.valor === true ||
                                dato.valor === "true" ? (
                                <Text
                                  style={{ fontSize: 16, color: "#52c41a" }}
                                >
                                  ✓
                                </Text>
                              ) : dato.valor === false ||
                                dato.valor === "false" ? (
                                <Text
                                  style={{ fontSize: 16, color: "#ff4d4f" }}
                                >
                                  ✗
                                </Text>
                              ) : (
                                <Text style={{ fontSize: 13 }}>
                                  {String(dato.valor)}
                                </Text>
                              )}
                            </div>

                            {/* Botón ir al documento */}
                            {dato.esDocumento && (
                              <Tooltip title={`Ir a ${dato.nombreCampo}`}>
                                <ButtonItem
                                  type="primary"
                                  negro2
                                  size="small"
                                  icon={<ExportOutlined />}
                                  onClick={() =>
                                    irADocumento(
                                      dato.rutaDocumento,
                                      dato.documentoId,
                                    )
                                  }
                                />
                              </Tooltip>
                            )}
                          </div>
                        ))}
                      </Panel>
                    ),
                  )}
                </Collapse>
              )}
            </Spin>
          </TabPane>
        </Tabs>
      </Drawer>
    </>
  );
};

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
});

export default withRouter(connect(mapStateToProps)(DrawerLead));
